import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { AboutMe } from "../aboutme/AboutMe";
import _axiosInstance from "../../shared/services/axios.instance";
const Home = () => {
  const [data, setData] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);
  const [homeObj, setHomeObj] = useState({
    image_url: "",
  });
  useEffect(() => {
    const getData = async () => {
      try {
        const result = await _axiosInstance.get("home");
        if (result.data.status === "ok") {
          setData(result.data.data);
          let resBody = result.data.data;
          setData(resBody);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };
    const getLinks = async () => {
      try {
        const dataResult = await _axiosInstance.get("socialmedia");
        // console.log("ER", result);
        if (dataResult.data.status === "ok") {
          let resBody = dataResult.data.data;
          setSocialMedia(resBody);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };

    const getHomePicture = async () => {
      return;
      // try {
      //   const dataResult = await _axiosInstance.post("image/getsingleimage", {
      //     type: "hompage",
      //   });
      //   if (dataResult.data.status === "ok") {
      //     let resBody = dataResult.data.data;
      //     setHomeObj(resBody);
      //     console.log(resBody);
      //   }
      // } catch (error) {
      //   console.log("Error", error);
      // }
    };

    getData();
    getLinks();
    getHomePicture();
  }, []);
  return (
    <>
      <section className="main-banner-section">
        <div className="container">
          <div className="content-section">
            <div className="top-content">
              <div className="item-img home">
                <img
                  className="homeImage"
                  // src={
                  //   homeObj && homeObj.image_url !== undefined
                  //     ? homeObj.image_url
                  //     : ""
                  // }
                  src="../../assets/images/profile.jpeg"
                  alt="img"
                />
              </div>
              <div className="item-content">
                <div className="item-top-text">
                  {data ? data.greeting : "Hello"}
                </div>
                <div className="item-title">
                  <h1>
                    I am
                    {data && data.name ? " " + data.name : " -"}
                  </h1>
                </div>
                <div className="item-intro">
                  <h2>
                    <span> {data ? data.job_designation : "-"}</span>
                  </h2>
                </div>
              </div>
            </div>
            <div className="bottom-content">
              <div className="item-social">
                <ul>
                  {socialMedia.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link
                          to={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={`fa ${item.icon}`}></i>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AboutMe data={data} />
    </>
  );
};
export { Home };
